import { create } from 'zustand'
import { rhAPI } from '../../api'
import { Funcionario, FuncionarioResume } from '../../types/rh/funcionario'

interface FuncionariosState {
  cleanFuncionarioState: () => void
  //FUNCIONARIOS LIST
  filters: FiltersFuncionarios
  cleanedFilters: FiltersFuncionarios
  setFilters: (filters: FiltersFuncionarios | ((prev: FiltersFuncionarios) => FiltersFuncionarios)) => void
  cleanFilters: () => void
  isFiltered: () => boolean
  funcionarios: Funcionario[]
  setFuncionarios: (filters: FiltersFuncionarios) => Promise<void>
  loadingFuncionarios: boolean,
  setLoadingFuncionarios: (loading: boolean) => void
  erroFuncionarios: boolean,
  setErroFuncionarios: (erro: boolean) => void
  messageErroFuncionarios: string
  totalPages: number
  totalItems: number

  //FUNCIONARIOS RESUME
  funcionariosResume: FuncionarioResume[]
  setFuncionariosResume: () => Promise<void>
  erroFuncionariosResume: boolean
  loadingFuncionariosResume: boolean
  setErroFuncionariosResume: (erro: boolean) => void

  //FUNCIONARIO REGISTER
  selectedFuncionarioId: number
  setSelectedFuncionarioId: (id: number) => void
}

export interface FiltersFuncionarios {
  pesquisarPor: number
  pesquisar: string
  pesquisarSetor: string
  pesquisarFilial: string
  admissaoDe: string
  admissaoAte: string
  demissaoDe: string
  demissaoAte: string
  afastamentoDe: string
  afastamentoAte: string
  feriasDe: string
  feriasAte: string
  centroCusto: number[]
  status: number
  sortField: string,
  sort: "asc" | "desc"
  page: number
  pageSize: number
}

export const useFuncionariosStore = create<FuncionariosState>((set, get) => ({
  cleanFuncionarioState: () => {
    set(() => ({
      funcionarios: [],
      totalPages: 0,
      totalItems: 0,
      loadingFuncionarios: false,
      erroFuncionarios: false,
      messageErroFuncionarios: "",
      filters: { pesquisarPor: 0, pesquisar: "", pesquisarSetor: "", pesquisarFilial: "", admissaoDe: "", admissaoAte: "", demissaoDe: "", demissaoAte: "", afastamentoDe: "", afastamentoAte: "", feriasDe: "", feriasAte: "", centroCusto: [], status: 1, sortField: "nome", sort: "asc", page: 1, pageSize: 25 },
      funcionariosResume: [],
      erroFuncionariosResume: false,
      loadingFuncionariosResume: false,
      selectedFuncionarioId: 0
    }))
  },
  //FUNCIONARIOS LIST
  funcionarios: [],
  setFuncionarios: async (filters: FiltersFuncionarios) => {
    set(() => ({ loadingFuncionarios: true, erroFuncionarios: false }))
    const result = await rhAPI.getfuncionarios(filters)
    if (result.statusCode == 200 && result.data) {
      set(() => ({
        funcionarios: result.data?.items ?? [], filters: { ...filters, page: result.data?.currentPage ?? 1, pageSize: result.data?.pageSize ?? 25 }, totalPages: result.data?.totalPages ?? 0, totalItems: result.data?.totalItems ?? 0
      }))
    }
    else {
      set(() => ({ erroFuncionarios: true, messageErroFuncionarios: result.error?.Message ?? "Ocorreu um erro inesperado." }))
    }
    set(() => ({ loadingFuncionarios: false }))
  },
  totalPages: 0,
  totalItems: 0,
  loadingFuncionarios: false,
  setLoadingFuncionarios: (loading: boolean) => {
    set(() => ({ loadingFuncionarios: loading }))
  },
  erroFuncionarios: false,
  setErroFuncionarios: (erro: boolean) => {
    set(() => ({ erroFuncionarios: erro }))
  },
  messageErroFuncionarios: "",
  cleanedFilters: { pesquisarPor: 0, pesquisar: "", pesquisarSetor: "", pesquisarFilial: "", admissaoDe: "", admissaoAte: "", demissaoDe: "", demissaoAte: "", afastamentoDe: "", afastamentoAte: "", feriasDe: "", feriasAte: "", centroCusto: [], status: 1, sortField: "nome", sort: "asc", page: 1, pageSize: 25 },
  filters: { pesquisarPor: 0, pesquisar: "", pesquisarSetor: "", pesquisarFilial: "", admissaoDe: "", admissaoAte: "", demissaoDe: "", demissaoAte: "", afastamentoDe: "", afastamentoAte: "", feriasDe: "", feriasAte: "", centroCusto: [], status: 1, sortField: "nome", sort: "asc", page: 1, pageSize: 25 },
  setFilters: (filters) => {
    set((state) => ({
      filters: typeof filters === 'function' ? filters(state.filters) : filters,
    }))
  },
  cleanFilters: () => {
    set(() => {
      const { setFuncionarios, cleanedFilters } = get()
      setFuncionarios(cleanedFilters)
      return ({
        filters: cleanedFilters
      })
    })
  },
  isFiltered: () => {
    const { filters } = get()
    if (filters.pesquisarPor != 0 || filters.pesquisar != "" || filters.pesquisarSetor != "" || filters.pesquisarFilial != "" || filters.admissaoDe != "" || filters.admissaoAte != "" || filters.demissaoDe != "" || filters.demissaoAte != "" || filters.afastamentoDe != "" || filters.afastamentoAte != "" || filters.feriasDe != "" || filters.feriasAte != "" || filters.centroCusto.length != 0 || filters.status != 1) {
      return true
    }
    return false
  },

  //FUNCIONARIOS RESUME
  funcionariosResume: [],
  erroFuncionariosResume: false,
  loadingFuncionariosResume: false,
  setFuncionariosResume: async () => {
    set(() => ({ loadingFuncionariosResume: true, erroFuncionariosResume: false }))
    const result = await rhAPI.getFuncionariosResume()
    if (result.statusCode == 200 && result.data) {
      set(() => ({ funcionariosResume: result.data }))
    }
    else {
      set(() => ({ erroFuncionariosResume: true, funcionariosResume: [] }))
    }
    set(() => ({ loadingFuncionariosResume: false }))
  },
  setErroFuncionariosResume: (erro: boolean) => {
    set(() => ({ erroFuncionariosResume: erro }))
  },

  //FUNCIONARIO REGISTER
  selectedFuncionarioId: 0,
  setSelectedFuncionarioId: (id: number) => {
    set(() => ({ selectedFuncionarioId: id }))
  }
}))